import React, { PureComponent } from 'react';

import MapWidget from '~/core/scripts/widgets/ChoroplethMapWidget';
import MapLegend from '~/kits/general/components/MapLegend';
import { is375Query } from '~/core/scripts/mediaquery-helper';
import { steps, colorScale } from '~/kits/general/utils';

class MapView extends PureComponent {
  render() {
    const { geoData, currentStep, highlightColor } = this.props;
    return (
      <div className="mapview">
        <MapLegend items={colorScale.filter((d, i) => i > 0).map(step => step[1])} />
        <MapWidget
          minZoom={is375Query() ? 2.5 : 2}
          geoData={geoData}
          valueKey={steps[currentStep]}
          zoomControl={false}
          showMapToggleButton={false}
          colorSteps={colorScale}
          zoomDelta={0.1}
          zoomSnap={0.1}
          highlightColor={highlightColor}
        />
      </div>
    );
  }
}

export default MapView;
